import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useFetchUser } from "../../hooks/user/useFetchUser";
import { Roles } from "../../constants/UserRoles";
import {
  COMING_SOON_ENABLED,
  COMING_SOON_ALLOWED_PATHS,
} from "../../constants/comingSoon";
import ComingSoon from "../../pages/ComingSoon";
import Loading from "../common/Loading";

/**
 * Resolves the signed-in user's role and renders the app only for admins.
 * Split out so useFetchUser (which needs a token) never runs for anonymous
 * visitors.
 */
const AdminOnly = ({ children }) => {
  const { data: user, isLoading, error } = useFetchUser();

  if (isLoading) return <Loading />;
  if (error || user?.role !== Roles.Admin) return <ComingSoon />;

  return children;
};

/**
 * Temporary wall: while COMING_SOON_ENABLED is on, every visitor who is not an
 * authenticated admin sees the coming-soon page instead of the app.
 *
 * This is a front-end wall, not an authorization boundary — the API still has
 * to enforce its own access rules.
 */
const ComingSoonGate = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const { pathname } = useLocation();

  if (!COMING_SOON_ENABLED) return children;

  // Auth routes stay open so an admin can still sign in.
  if (COMING_SOON_ALLOWED_PATHS.includes(pathname)) return children;

  if (isLoading) return <Loading />;
  if (!isAuthenticated) return <ComingSoon />;

  return <AdminOnly>{children}</AdminOnly>;
};

export default ComingSoonGate;
